import React, { PureComponent } from 'react';
import icons from '../../../components/shared/treatedIcons';
import {
  IdTd,
  BaixarTd,
  VencimentoTd,
  ReferenciaTd,
  RequestRow,
  DateTd,
  BaseEllipsisSpan,
  MobileRequestCard,
  MobileRequestCardBody,
  MobileRequestGrid,
  MobileRequestField,
  MobileRequestLabel,
  MobileRequestValue,
  MobileRequestActionButton
} from './requestTable.styled';
import RequestTableToolTip from './RequestTableToolTip';
import { formatCNPJ, formatCPF, formatAddress, formatToBRL } from '../../../utils/formatter';
import { IconCell } from '../../../components/shared/table/styled';

import ModalPixQrCode from './ModalPixQrCode';

import QRCode from 'react-qr-code';

const { Eye } = icons;

const avisoNotaGov = 'Link do governo. Só abre com o certificado digital.';

class RequestLine extends PureComponent {

  state = {
    modalIsOpen: false
  }

  getApplicantNames = () => {
    const { pretendentes } = this.props;
    if (Array.isArray(pretendentes) && pretendentes.length > 0) {
      return pretendentes.map((applicant) => {
        let nome = applicant.nome || applicant.razao_social
        if(Boolean(applicant.oculto) === true) {
          nome = 'IDENTIFICAÇÃO OCULTADA'
        }
        return nome
      });
    }
    return [];
  }

  getApplicantDocs = () => {
    const { pretendentes } = this.props;
    if (Array.isArray(pretendentes) && pretendentes.length > 0) {
      return pretendentes.map((applicant) => {
        if(Boolean(applicant.oculto) === true) {
          return 'OCULTADO'
        }

        if ("cpf" in applicant) {
          return formatCPF(applicant.cpf);
        }

        if ("cnpj" in applicant) {
          return formatCNPJ(applicant.cnpj);
        }
      });
    }
    return [];
  }

  getAdress = () => {
    const { endereco } = this.props;

    if( Array.isArray(endereco) && endereco.length > 0){
      return `${formatAddress(endereco[0])}`
    }else{
      return "-"
    }
  }

  formatReferencia = () => {
    let format = this.props.referencia.split('/')
    let month = ''
    switch(format[0]) {
      case '1':
        month = 'Janeiro'
        break;
      case '2':
        month = 'Fevereiro'
        break;
      case '3':
        month = 'Março'
        break;
      case '4':
        month = 'Abril'
        break;
      case '5':
        month = 'Maio'
        break;
      case '6':
        month = 'Junho'
        break;
      case '7':
        month = 'Julho'
        break;
      case '8':
        month = 'Agosto'
        break;
      case '9':
        month = 'Setembro'
        break;
      case '10':
        month = 'Outubro'
        break;
      case '11':
        month = 'Novembro'
        break;
      case '12':
        month = 'Dezembro'
        break;
    }
    return `${month}/${format[1].substr(2)}`
  }

  handleGetBoleto = () => {
    if(this.props.caminho_boleto) {
      window.open(this.props.caminho_boleto, '_blank')
    } else {
      this.setState({modalIsOpen: true})
    }
  }

  handleGetNotaFiscal = (event) => {
    event.stopPropagation()
    const url = this.props.caminho_nota_fiscal || this.props.nota_fiscal_url
    if (url) {
      window.open(url, '_blank')
    }
  }

  render() {
    const applicantNames = this.getApplicantNames();
    const applicantDocs = this.getApplicantDocs();
    const adress = this.getAdress();
    const canViewBoleto = this.props.status === 'à pagar' || this.props.status === 'vencido';

    if (this.props.isMobile) {
      return (
        <MobileRequestCard>
          <MobileRequestCardBody>
            <MobileRequestGrid>
              <MobileRequestField>
                <MobileRequestLabel>ID Cobrança</MobileRequestLabel>
                <MobileRequestValue>{this.props.id || '-'}</MobileRequestValue>
              </MobileRequestField>
              <MobileRequestField>
                <MobileRequestLabel>ID-FC</MobileRequestLabel>
                <MobileRequestValue>{this.props.solicitacao_id || '-'}</MobileRequestValue>
              </MobileRequestField>
              <MobileRequestField>
                <MobileRequestLabel>Valor</MobileRequestLabel>
                <MobileRequestValue>R$ {formatToBRL(this.props.valor_final)}</MobileRequestValue>
              </MobileRequestField>
              <MobileRequestField>
                <MobileRequestLabel>Referência</MobileRequestLabel>
                <MobileRequestValue>{this.formatReferencia()}</MobileRequestValue>
              </MobileRequestField>
              <MobileRequestField>
                <MobileRequestLabel>Vencimento</MobileRequestLabel>
                <MobileRequestValue>{this.props.vencimento || '-'}</MobileRequestValue>
              </MobileRequestField>
              <MobileRequestField>
                <MobileRequestLabel>Status</MobileRequestLabel>
                <MobileRequestValue>{this.props.status || '-'}</MobileRequestValue>
              </MobileRequestField>
              <MobileRequestField>
                <MobileRequestLabel>Nota fiscal</MobileRequestLabel>
                <MobileRequestValue>
                  {(this.props.caminho_nota_fiscal || this.props.nota_fiscal_url) ? (
                    <MobileRequestActionButton type="button" title="Nota fiscal" onClick={this.handleGetNotaFiscal}>
                      <Eye />
                      {!this.props.caminho_nota_fiscal && <span title={avisoNotaGov} style={{color:'#b45309', fontWeight:700, marginLeft:6, cursor:'help'}}>!</span>}
                    </MobileRequestActionButton>
                  ) : (
                    '-'
                  )}
                </MobileRequestValue>
              </MobileRequestField>
              <MobileRequestField>
                <MobileRequestLabel>Visualizar</MobileRequestLabel>
                <MobileRequestValue>
                  {canViewBoleto ? (
                    <MobileRequestActionButton type="button" onClick={this.handleGetBoleto}>
                      <Eye />
                    </MobileRequestActionButton>
                  ) : (
                    '-'
                  )}
                </MobileRequestValue>
              </MobileRequestField>
            </MobileRequestGrid>
            <ModalPixQrCode
              undo={this.handleButtonCancelarBaixa}
              isOpen={this.state.modalIsOpen}
              onClose={() => this.setState({modalIsOpen: false, justificativa: ''})}
              handleJustificativa={this.handleJustificativa}
              pixCopiaECola={this.props.pix_copia_cola}
              pixCriacao={this.props.pix_criacao}
              valorFinal={this.props.valor_final}
              selectedIdCobranca={this.props.id}
              formatToBRL={formatToBRL}
            />
          </MobileRequestCardBody>
        </MobileRequestCard>
      );
    }
    
    return (
      <RequestRow onClick={this.props.onGoToResume} >
        <IdTd>
          <BaseEllipsisSpan>{this.props.id}</BaseEllipsisSpan>
        </IdTd>
        <IdTd>
          {/* <BaseEllipsisSpan>{this.props.solicitacao_id}</BaseEllipsisSpan> */}
          {this.props.solicitacao_id && this.props.solicitacao_id.includes(',') === true
              ?
                <RequestTableToolTip
                  message={this.props.solicitacao_id}
                  index={this.props.index}
                  length={this.props.length}
                  type="customerName"
                >
                  <BaseEllipsisSpan id={`customerName${this.props.index}`} style={{position: 'relative', width: 'fit-content', overflow: 'visible'}}>{this.props.solicitacao_id.split(',')[0]}<div style={{position: 'absolute', top: -2, right: -9, backgroundColor: '#1399cd85', width: 7, height: 7, borderRadius: '50%'}}></div></BaseEllipsisSpan>    
                </RequestTableToolTip>
              :
                <BaseEllipsisSpan>{this.props.solicitacao_id}</BaseEllipsisSpan>
            }
        </IdTd>
        <DateTd>
          <BaseEllipsisSpan>R$ {formatToBRL(this.props.valor_final)}</BaseEllipsisSpan>
        </DateTd>
        <ReferenciaTd>
            {this.formatReferencia()}
        </ReferenciaTd>
        <VencimentoTd>
          {this.props.vencimento}
        </VencimentoTd>
        <DateTd>
          <span>{this.props.status}</span>
        </DateTd>
        <BaixarTd>
          {(this.props.caminho_nota_fiscal || this.props.nota_fiscal_url) &&
            <IconCell title="Nota fiscal" onClick={this.handleGetNotaFiscal}>
              <Eye />
              {!this.props.caminho_nota_fiscal && <span title={avisoNotaGov} onClick={(event) => event.stopPropagation()} style={{color:'#b45309', fontWeight:700, marginLeft:6, cursor:'help'}}>!</span>}
            </IconCell>
          }
        </BaixarTd>
        <BaixarTd>
					{canViewBoleto &&
          	<IconCell onClick={this.handleGetBoleto}>
							<Eye />
						</IconCell>
					}
        </BaixarTd>
        <ModalPixQrCode
          undo={this.handleButtonCancelarBaixa}
          isOpen={this.state.modalIsOpen}
          onClose={() => this.setState({modalIsOpen: false, justificativa: ''})}
          handleJustificativa={this.handleJustificativa}
          pixCopiaECola={this.props.pix_copia_cola}
          pixCriacao={this.props.pix_criacao}
          valorFinal={this.props.valor_final}
					selectedIdCobranca={this.props.id}
          formatToBRL={formatToBRL}
        />
      </RequestRow>
    );
  }
}
export default RequestLine;
